import { Injectable } from '@angular/core';
import { LU_TermsModel } from 'scaletech-core';
import { HttpClient } from '@angular/common/http';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LU_TermService extends StarbaseDataService<LU_TermsModel> {
  protected _staleDataTimeout: number;
  protected _getOneUri= '/api/Terms/';
  protected _getAllUri= '/api/Terms';
  protected _postUri= '/api/Terms/';
  protected _putUri=  '/api/Terms/';
  protected _deleteUri = '/api/Terms/';
  protected _broadSearchUri = '/api/Terms/GetTermsByFilterParams';

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }

  public getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<LU_TermsModel>): Observable<FilterParams<LU_TermsModel>> {
    return super.getDataByFilterParamsBroadSearch(url, filterParams).pipe(
      map((l) => {
        l.collection = l.collection.map((lu) =>  new LU_TermsModel().deserialize(lu));

        return l;
      })
    );
  }

  public putData(url: string = this.putUri, id: string | number, changedObject: LU_TermsModel) {
    // eslint-disable-next-line eqeqeq
    if (changedObject.lastModifiedDateTime == null) {
      changedObject.lastModifiedDateTime = new Date();
    }
    return super.putData(url, id, changedObject);
  }


  public getAllData(url: string, retryCount?: number): Observable<LU_TermsModel[]> {
    return super.getAllData(url, retryCount).pipe(
      map((l: LU_TermsModel[]) =>
        l.map(
          (lu: LU_TermsModel) => {
            if (lu.lastModifiedDateTime) {
              const date = new Date(lu.lastModifiedDateTime);
              const year = date.getFullYear();
              if (year === 1 || year === 0) {
                lu.lastModifiedDateTime = null;
              }
            }
            return lu;
          })
      ));
  }
}
